export const colors = ['#FF5D1C', '#14c8f5', '#1aeb74', '#FED049', '#82C3EC', '#68B984', '#CE7777', '#DC3535'];
export const transparentColors = ['rgba(255, 93, 28, 0.7)', 'rgba(20, 200, 245, 0.7)', 'rgba(26, 235, 116, 0.7)', 'rgba(254, 208, 73, 0.7)', 'rgba(130, 195, 236, 0.7)', 'rgba(104, 185, 132, 0.7)', 'rgba(73, 113, 116, 0.7)', 'rgba(206, 119, 119, 0.7)', 'rgba(220, 53, 53, 0.7)'];
export const creators = {
    cats: 'Cats',
    dragons: 'Dragons',
    foxes: 'Foxes',
    dogs: 'Dogs',
};
export const games = {
    '3': 'Cats',
    '5': 'Dragons',
    '7': 'Foxes',
    '11': 'Dogs',
    '13': 'Elon',
};
export const resetChart = (chart, labels = null, datasets = null) => {
    var _a, _b;
    try {
        if (chart) {
            (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.$$) === null || _a === void 0 ? void 0 : _a.ctx[2]) === null || _b === void 0 ? void 0 : _b.resetZoom();
        }
        while (labels === null || labels === void 0 ? void 0 : labels.length) {
            labels.pop();
        }
        while (datasets === null || datasets === void 0 ? void 0 : datasets.length) {
            datasets.pop();
        }
    }
    catch (e) { }
};
export const processChartDataset = (data, labels, datasets, toStart = false, _idx = 0) => {
    if (_idx === 0) {
        data.branches[0].values.forEach(e => {
            labels.push(e.point || e.date);
        });
    }
    const currentDataset = [];
    let idx = _idx;
    for (const branch of data.branches) {
        currentDataset.push({
            label: branch.reasonsLabel || branch.label,
            backgroundColor: colors[idx],
            borderColor: colors[idx],
            fill: false,
            data: branch.values.map((v) => Math.abs(v.amount)),
            stack: 0,
        });
        idx++;
    }
    if (!toStart) {
        datasets.push(...currentDataset);
    }
    else {
        datasets.unshift(...currentDataset);
    }
};
